import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../../assets/xiaoniu-logo.png';
const _hoisted_1 = {
  id: "userLayout"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "background-color"
}, null, -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "user-background"
}, null, -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo"
}, null, -1);
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "logo-text"
}, "小牛知识分享网站", -1);
import '@/styles/UserLayout.scss';
import GlobalFooter from "@/components/layout/GlobalFooter";
import { onMounted } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'UserLayout',
  setup(__props) {
    onMounted(() => {
      // window.addEventListener('resize', function() {
      //   const userLayout:any = document.getElementById('userLayout');
      //   const viewportHeight = window.innerHeight;
      //   userLayout.style.minHeight = viewportHeight + 'px';
      // });
      // console.log(1)
    });
    return (_ctx, _cache) => {
      const _component_a_space = _resolveComponent("a-space");
      const _component_a_layout_header = _resolveComponent("a-layout-header");
      const _component_router_view = _resolveComponent("router-view");
      const _component_a_layout_content = _resolveComponent("a-layout-content");
      const _component_a_layout = _resolveComponent("a-layout");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _hoisted_3, _createVNode(_component_a_layout, null, {
        default: _withCtx(() => [_createVNode(_component_a_layout_header, {
          class: "header"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_space, null, {
            default: _withCtx(() => [_hoisted_4, _hoisted_5]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_a_layout_content, {
          class: "content"
        }, {
          default: _withCtx(() => [_createVNode(_component_router_view)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_unref(GlobalFooter))]);
    };
  }
});